<div class="error-message-container align-center">
    <img class="error-icon" src="/assets/icons/error@3x.png">
    <h5 class="white align-center" style="margin: 0px;">{{errorMessage}}</h5>
</div>